import { useEffect } from "react";

const divStyles = {
  position: 'relative',
  paddingBottom: '56.25%',
  width: '100%',
};

const iframeStyles = {
  position: 'absolute',
  border: 0,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
};

export interface H5FallbackProps {
  position: 'interstitial' | 'rewarded';
  onFinish: () => void;
}

export const H5Fallback = ({ position, onFinish }: H5FallbackProps) => {
  const base = 'https://ams.cdn.arkadiumhosted.com/advertisement/video/stable/h5/frames/';
  const src = base + position + '.html';

  useEffect(() => {
    const messageHandler = (message: any) => {
      if (message.data.type === 'h5-finish') onFinish();
    };
    window.addEventListener('message', messageHandler);
    return () => window.removeEventListener('message', messageHandler);
  }, []);

  return (
    <div style={divStyles}>
      <iframe src={src} allow="autoplay" style={iframeStyles} ></iframe>
    </div>
  );
}
